/**
 * Created with IntelliJ IDEA.
 * User: danielr
 * Date: 5/8/13
 * Time: 1:19 PM
 * To change this template use File | Settings | File Templates.
 *
 * the model for the top title
 */
define(function (require) {
    "use strict";

    var Backbone = require('backbone');

    var BubbleModel = Backbone.Model.extend({
        defaults : {
            text: "",
            title: ""
        },

        initialize : function () {
        },

        reset : function () {
        }

    });

    return BubbleModel;
});